<template>
  <Form @submit="handleSubmit" ref="leaveReportFilterForm" :validation-schema="schema" v-slot="{ errors }">
    <div class="row d-flex align-items-center">

      <!-- Division -->
      <CustomSelect2 v-if="showDivision" class-name="col-md-4" label="Division" name="division_id" option-label="label"
        :options="divisions" v-model="selectedDivision" :loading="loadingDivision" :read-only="loadingDivision"
        @dropdown-value-change="handleDivisionChange" @remove="handleDivisionRemove" :not-required="true" />

      <!-- Department -->
      <CustomSelect2 v-if="showDept" class-name="col-md-4" label="Department" name="department_id" option-label="label"
        :options="departments" v-model="selectedDept" :loading="loadingDept" :read-only="loadingDept"
        @dropdown-value-change="handleDeptChange" @remove="handleDeptRemove" :not-required="true" />

      <!-- Employee -->
      <CustomSelect2 v-if="!multipleEmployees" class-name="col-md-4" label="Employee" name="employee_personal_id" option-label="label"
        :options="employees" v-model="selectedEmployee" :loading="loadingEmployees" :read-only="loadingEmployees"
        :error="!isEmployeeRequired ? errors.employee_personal_id : false" :not-required="isEmployeeRequired"
         />

         <div class="col-md-4" v-else>
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Employee<span v-if="isEmployeeRequired" class="text-danger"></span
                  ></label>
                  <Field
                    v-slot="{ field }"
                    name="employee_personal_id"
                    :class="{ 'is-invalid': errors.employee_personal_id }"
                    class="form-control"
                  >
                    <multiselect
                      v-bind="field"
                      v-model="selectedEmployee"
                      :options="employees"
                      label="label"
                      track-by="value"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="true"
                      :searchable="true"
                      placeholder="Select Employee"
                      :disabled="loadingEmployees"
                      :loading="loadingEmployees"
                      :class="{ 'is-invalid': errors.employee_personal_id }"
                    >
                    </multiselect>
                  </Field>
                  <div v-if="isEmployeeRequired" class="invalid-feedback">
                    {{ errors.employee_personal_id }}
                  </div>
                  <div class="emailshow text-danger"></div>
                </div>
              </div>

    </div>

    <div class="row d-flex justify-content-end align-items-center">
      <!-- From -->
      <div class="col-md-5">
        <div class="input-block mb-3">
          <label class="col-form-label">From<span class="text-danger">*</span></label>
          <Field v-model="localValues.startDate" name="from" type="date" class="form-control" @change="resetEndDate"
            :class="{ 'is-invalid': errors.from }" />
          <div class="invalid-feedback">{{ errors.from }}</div>
        </div>
      </div>

      <!-- To -->
      <div class="col-md-5">
        <div class="input-block mb-3">
          <label class="col-form-label">To<span class="text-danger">*</span></label>
          <Field v-model="localValues.endDate" name="to" type="date" class="form-control"
            :class="{ 'is-invalid': errors.to }" />
          <div class="invalid-feedback">{{ errors.to }}</div>
        </div>
      </div>
      <!-- Button -->
      <div class="col-md-2 mt-3">
        <button class="btn btn-info w-100">Search</button>
      </div>
    </div>
  </Form>
</template>

<script>
import { Form, Field } from "vee-validate";
import EmployeeService from "@/services/EmployeeService";
import DivisionService from "@/services/DivisionService";
import CustomSelect2 from "./CustomSelect2.vue";
import DepartmentService from "@/services/DepartmentService";
import * as Yup from "yup";
import { computed } from "vue";
import Multiselect from "vue-multiselect";

export default {
  name: "LeaveFilterForm",
  components: {
    Form,
    Field,
    CustomSelect2,
    Multiselect,
  },

  props: {
    initialValues: {
      type: Object,
      default: () => ({
        startDate: "",
        endDate: ""
      })
    },
    showDivision: {
      type: Boolean,
      default: true,
    },
    showDept: {
      type: Boolean,
      default: true,
    },
    multipleEmployees: {
      type: Boolean,
      default: false,
    },
    isEmployeeRequired: {
      type: Boolean,
      default: false,
    }
  },

  emits: ["submit"],

  data() {
    return {
      localValues: { ...this.initialValues },
      employees: [],
      selectedEmployee: null,
      loadingEmployees: false,
      divisions: [],
      selectedDivision: null,
      loadingDivision: false,
      departments: [],
      selectedDept: null,
      loadingDept: false,
    };
  },

  methods: {
    resetEndDate() {
      this.localValues.endDate = "";
    },
    async fetchEmployees() {
      this.loadingEmployees = true;
      try {
        const res = await EmployeeService.getAllEmployees();
        this.employees = res?.data?.map(el => ({
          value: el.id,
          label: `${el.employee_name}`,
        }));
      } finally {
        this.loadingEmployees = false;
      }
    },
    async fetchDivisions() {
      this.loadingDivision = true;
      try {
        const responseDivions = await DivisionService.getDivisions();
        this.divisions = responseDivions.data.map((el) => {
          return {
            value: el.id,
            label: el.name,
          };
        });
      } catch (error) {
        console.log('error fetching divisions', error);
      } finally {
        this.loadingDivision = false;
      }
    },
    async fetchDepartments() {
      this.loadingDept = true;
      try {
        const response = await DepartmentService.getDepartments();
        this.departments = response.data.map((el) => {
          return {
            value: el.id,
            label: el.name,
          };
        });
      } catch (error) {
        console.log('error fetching departments', error);
      } finally {
        this.loadingDept = false;
      }
    },
    async handleDivisionChange() {
      this.loadingDept = true;
      this.loadingEmployees = true;
      this.selectedDept = [];
      this.selectedEmployee = [];
      try {
        const divisionId = this.selectedDivision?.value;
        if (this.showDept) {
          const response = await DepartmentService.getDepartmentsDivisionWise(
            divisionId
          );
          this.departments = response.data.map((el) => {
            return {
              value: el.id,
              label: el.name,
            };
          });
        }
        const payload = {
          division_id: divisionId,
        }
        const responseEmp = await EmployeeService.fetchDivisionWiseEmployee(
          payload,
        );
        this.employees = responseEmp.data.map((el) => {
          return {
            value: el.id,
            label: el.name,
          };
        });
      } catch (error) {
        this.departments = [];
        console.log(
          "response error from EmployeeService.getDepartmentEmployees",
          error
        );
      } finally {
        this.loadingDept = false;
        this.loadingEmployees = false;
      }
    },
    async handleDivisionRemove() {
      this.fetchDepartments();
      this.fetchEmployees();
    },
    async handleDeptChange() {
      this.loadingEmployees = true;
      this.selectedEmployee = [];
      try {
        const departmentId = this.selectedDept?.value;
        const responseEmp = await EmployeeService.getDepartmentEmployees(
          departmentId,
        );
        this.employees = responseEmp.data.map((el) => {
          return {
            value: el.id,
            label: el.employee_name,
          };
        });
      } catch (error) {
        this.employees = [];
        console.log(
          "response error from EmployeeService.getDepartmentEmployees",
          error
        );
      } finally {
        this.loadingEmployees = false;
      }
    },
    async handleDeptRemove() {
      this.fetchEmployees();
    },
    handleSubmit(values) {
      const payload = {
        ...values,
        startDate: this.localValues.startDate,
        endDate: this.localValues.endDate,
        employeeIds: this.selectedEmployee,
      };
      if (this.showDivision) {
        payload['division_id'] = this.selectedDivision;
      }
      if (this.showDept) {
        payload['department_id'] = this.selectedDept;
      }


      this.$emit("submit", payload);
    },

  },
  created() {
    this.fetchEmployees();
    if (this.showDivision) {
      this.fetchDivisions();
    }
    if (this.showDept) {
      this.fetchDepartments();
    }
  },
  setup(props) {
    const schema = computed(() => {
      return Yup.object().shape({
        from: Yup.string().required("From is required"),
        to: Yup.string().required("To is required"),
        employee_personal_id: props.isEmployeeRequired
          ? Yup.mixed().nullable() // not required
          : Yup.mixed().required("Employee is required"),
      });
    });
    return {
      schema,
    };
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
